/**
 * Erro de regra de negócio cuja mensagem é a resposta final ao usuário (toast) —
 * ex.: "crie outra categoria antes de apagar esta". Não é falha de código, então
 * o handler global de mutations NÃO reporta ao Sentry (viraria ruído na cota).
 */
export class ExpectedError extends Error {}

/**
 * Regra de negócio cuja resposta é DA TELA, não do toast: o call site captura o
 * erro e abre a própria UI de saída (diálogo com opções, sheet etc.). O handler
 * global de mutations pula o Sentry (herda de ExpectedError) E o toast — senão o
 * usuário vê "Algo deu errado" POR CIMA do diálogo que resolve (visto em produção
 * no bloqueio de reativação de caixinha: Sentry REACT-NATIVE-13, 7 tentativas do
 * mesmo usuário em 19 min, provavelmente reagindo ao toast como se fosse falha).
 *
 * Contrato: só use isto se TODO call site da mutation tratar o erro — um call
 * site sem catch deixaria a falha 100% muda.
 */
export class HandledByCallerError extends ExpectedError {}

export function getErrorMessage(error: unknown, fallback = 'Tente novamente.'): string {
    if (error instanceof Error) return error.message;
    if (typeof error === 'string') return error;
    return fallback;
}
